import apiCallTemplate from "./config";
import credentials from "../assets/credentials";

const { BASE_URL } = credentials;
const cartURL = `${BASE_URL}/cart`;

// Add item to cart
export const addToCart = async (assetId) =>
  apiCallTemplate("post", `${cartURL}/add`, { assetId });

// Get user's cart
export const getCart = async () =>
  apiCallTemplate("get", `${cartURL}`);

// Remove specific item from cart
export const removeFromCart = async (assetId) =>
  apiCallTemplate("delete", `${cartURL}/remove/${assetId}`);

// Clear entire cart
export const clearCart = async () =>
  apiCallTemplate("delete", `${cartURL}/clear`);

// Get total items count in cart
export const getCartCount = async () =>
  apiCallTemplate("get", `${cartURL}/count`);
